import { TempUrl, getBaseApiUrl } from "./../env";
import { baseUrl, GenaiUrl, CreateQuizUrl } from "./../env";
import BaseAPI from "./baseAPI";
export let  getStudentid = window.location.pathname.split("/")[3];
let params = new URL(document.location).searchParams;
let type = params.get("type");
let section_id = params.get("section_id");

if (window.location.pathname.includes(GenaiUrl) || window.location.pathname.includes(CreateQuizUrl) || window.location.pathname.includes(TempUrl)) {
  getStudentid = "undefined";
}

type = type === 'assessment' ? 'assessments' : 'quiz'
const getQuizUrl = (quiz_id) => `${getBaseApiUrl()}/${type}/${quiz_id}/?id=${getStudentid}`;

const getReviewTestUrl = (quiz_id) => `${getBaseApiUrl()}/${type}/${quiz_id}/?section_id=${section_id}`;

const getEditQuizUrl = (quiz_id) => `${getBaseApiUrl()}/${type}/edit/${quiz_id}/`;

const getSubmissionUrl = (quiz_id) => `${baseUrl}/student_submission_status/${quiz_id}`;

const gettestSubmissionUrl = (quiz_id) => `${baseUrl}/student_test_status/${quiz_id}`;

class API extends BaseAPI {
  constructor(props) {
    super(props);
    this.props = props;
  }

  get = ({ id }) => {
    if (section_id)
    {
      return this.fetchSecure({ url: getReviewTestUrl(id) });
    }
    else{
      return this.fetchSecure({ url: getQuizUrl(id) });
    }
  };

  getformdata = (generate_quiz) => {
    return this.fetchSecure({ url: `${getBaseApiUrl()}/${type}/generate/` });
  };

  get_submission_status = ({ id }) => {
    if(type === 'assessments'){
      return this.fetchSecure({ url: gettestSubmissionUrl(id) });
    }
    else{
      return this.fetchSecure({ url: getSubmissionUrl(id) });
    }
  };
  get_ai_feedback_status = ({ id }) => {
    return this.fetchSecure({ url: `${baseUrl}/a/ai_feedback_status/${id}` });
  };
  post = ({ id, data }) => {
    if (data?.is_edit)
    {
      return this.postSecure({ url: getEditQuizUrl(id), data });
    }
    else if (data?.exercise_saved)
    {
      return this.postSecure({ url: `${getBaseApiUrl()}/${type}/saved/${id}`, data });
    }
    else if (data?.gen_feedback)
    {
      return this.postSecure({ url: `${getBaseApiUrl()}/${type}/generate/feedback/${id}`, data });
    }
    else if (data?.gen_marking_scheme)
    {
      return this.postSecure({ url: `${getBaseApiUrl()}/${type}/generate/marking-scheme/${id}`, data });
    }
    else{
      return this.postSecure({ url: getQuizUrl(id), data });
    }
  };
  
  postformdata = ({data}) => {
    if (data.is_create)
    {
      return this.postSecure({ url: `${getBaseApiUrl()}/${type}/create/`, data });
    }
    else{
      return this.postSecure({ url: `${getBaseApiUrl()}/${type}/generate/quiz`, data });
    }
  };
}

const apiInstance = new API();
export default apiInstance;
